import axios  from "axios";
import qs from 'qs'
import {baseUrl} from './global'
import router from '../router'
import {refreshToken} from "./home"
import { getToken } from '../utils/auth'
axios.interceptors.request.use(
    config => {
      let data =JSON.parse(localStorage.getItem('datas')) 
      let token = getToken();
      config.headers.token = token
      return config;
    },
    err => {
      return Promise.reject(err);
    }
  );
  axios.interceptors.response.use(
    response => {
      console.log(response.data.code, "response.data.code");
      console.log(response.config, "response.config");
      const originalRequest = response.config;
      originalRequest._retry = true;
      if(response.data.code == 502){
        // 登录过期，调刷新函数
        // let data = JSON.parse(localStorage.getItem('datas')) 
        // let refreshTokens = data && data.qrAuth.refreshToken ? data.qrAuth.refreshToken:""
        // let params = {
        //   refreshToken:refreshTokens
        // }
        // router.beforeEach((to,from,next)=>{
        //   if(to.path == '/home'){
        //     next()
        //   }else{
        //     next("/login")
            
        //   }
        // })
        // 登录过期清除缓存，重新登录
        sessionStorage.removeItem('datas')
        localStorage.removeItem('datas')
        router.push({ path: '/login' })
       
        // request(refreshToken,params).then(res=>{
        //   let datas = JSON.stringify(res.data);
        //   let token = res.data.qrAuth.accessToken;
        //   sessionStorage.setItem("datas", datas);
        //   localStorage.setItem("datas", datas);
        //   // this.$store.commit("SETTOKENS", token);
        // })
        // return axios(originalRequest);
      }else if(response.data.code == 402){
        // 刷新token过期，清除缓存，重新登录
        sessionStorage.removeItem('datas')
        localStorage.removeItem('datas')
        // this.$store.commit('SETTOKENS', "")
        router.push({ path: '/' })
      }
      
      return Promise.resolve(response);
    },
    error => {
      return Promise.reject(error);
    }
  );
  // export function request(path, data = {}, header) {
  //   const searchParams = new URLSearchParams();
  
  //   // 将对象中的数据添加到URLSearchParams对象中
  //   for (let key in data) {
  //     if (data.hasOwnProperty(key)) {
  //       searchParams.append(key, data[key]);
  //     }
  //   }
  //   return new Promise((resolve, reject) => {
  //     axios({
  //       // baseURL: baseUrl, // api 的 base_url
  //       timeout: 50000, // 请求超时时间
  //       method: path.method || "post",
  //       url:`${baseUrl}${path.path}` ,
  //       params: path.method == "get" ? data : {},
  //       // 判断是否有自定义头部，以对参数进行序列化。不定义头部，默认对参数序列化为查询字符串。
  //       data: searchParams,
  //       // // 设置默认请求头
  //       headers: header || { "Content-Type": "application/x-www-form-urlencoded"}        
  //     })
  //       .then(response => {
  //         resolve(response.data);
  //       })
  //       .catch(error => {
  //         reject(error);
  //       });
  //   });
  // }
  export function request(path, data = {}, header) {
    return new Promise((resolve, reject) => {
      axios({
        // baseURL: baseUrl, // api 的 base_url
        timeout: 50000, // 请求超时时间
        method: path.method || "post",
        url:`${baseUrl}${path.path}` ,
        params: path.method == "get" || path.method == "GET" ? data : {},
        // 判断是否有自定义头部，以对参数进行序列化。不定义头部，默认对参数序列化为查询字符串。
        data: data,
        // // 设置默认请求头
        headers: header || { "Content-Type": "application/json"}        
      })
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
// 文件下载
export function requestdown(path,data={},header){
  return new Promise((resolve,reject)=>{
    axios({
      // baseURL: baseUrl, // api 的 base_url
      timeout: 50000, // 请求超时时间
      method: path.method || "post",
      url: `${baseUrl}${path.path}`,
      // params: path.method == "get"||"GET" ? data : {},
      // 判断是否有自定义头部，以对参数进行序列化。不定义头部，默认对参数序列化为查询字符串。
      // data: header ? data : qs.stringify(data),
      params: path.method == "get" || path.method == "GET" ? data : {},
        // 判断是否有自定义头部，以对参数进行序列化。不定义头部，默认对参数序列化为查询字符串。
        data:JSON.stringify(data),
      // data:data,
      // // 设置默认请求头
      headers: header || { "Content-Type": "application/json" },
      responseType:"blob"
        // headers: header || { "Content-Type": "application/x-www-form-urlencoded"}

    })
    .then(response => {
      // debugger
      resolve(response);
    })
    .catch(error => {
      reject(error);
    });
  })
}
// 文件上传
export function requestFile(path, data = {}, header) {
  const formDate = new FormData()
  formDate.set("file", data.file)
  formDate.append("id",data.id)
  return new Promise((resolve, reject) => {

    axios({
        // baseURL: baseUrl, // api 的 base_url
        timeout: 50000, // 请求超时时间
        method: path.method || "post",
        url: `${baseUrl}${path.path}`,
        // params: path.method == "get"||"GET" ? data : {},
        // 判断是否有自定义头部，以对参数进行序列化。不定义头部，默认对参数序列化为查询字符串。
        // data: header ? data : qs.stringify(data),
        data: formDate,
        // data:data,
        // // 设置默认请求头
        headers: header || { "Content-Type": "application/json" }
          // headers: header || { "Content-Type": "application/x-www-form-urlencoded"}

      })
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        reject(error);
      });
  });
}



// WEBPACK FOOTER //
// ./src/api/http.js